
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    bgIMG: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      required: true,
    },
    isCenter: {
      type: Boolean,
      required: true,
    },
  },
});
